export default{dataTableCellStatus:"w_Gm"};
